import {EnvironmentResource} from "../../../../client/resources/environmentResource";
import * as URI from "urijs";
import {MachineResource} from "../../../../client/resources/machineResource";

export default (root: string) => {
    const infraRoot = `${root}/infrastructure`;
    return {
        root: infraRoot,
        overview: `${infraRoot}/overview`,
        environments: {
            root: `${infraRoot}/environments`,
            create: `${infraRoot}/environments/create`,
            filtered: (obj: object) => `${infraRoot}/environments${(new URI()).search(obj).search()}`
        },
        environment: (environmentId: string | EnvironmentResource) => {
            if (!!environmentId && typeof environmentId !== "string") {
                environmentId = environmentId.Id;
            }
            return `${infraRoot}/environments/${environmentId}`;
        },
        machines: {
            root: `${infraRoot}/machines`,
            create: `${infraRoot}/machines/create`,
            filtered: (obj: object) => `${infraRoot}/machines${(new URI()).search(obj).search()}`,
            discover: (environmentId?: string) => `${infraRoot}/machines/discover${environmentId ? `/${environmentId}` : ""}`
        },
        machine: (machineId: string | MachineResource) => {
                if (!!machineId && typeof machineId !== "string") {
                    machineId = machineId.Id;
                }
                const machineRoot = `${infraRoot}/machines/${machineId}`;
                return {
                    root: machineRoot,
                    settings: `${machineRoot}/settings`,
                    deployments: `${machineRoot}/deployments`,
                    connection: `${machineRoot}/connection`,
                    events: `${machineRoot}/events`
                };
        },
        proxies: {
            root: `${infraRoot}/proxies`,
            create: `${infraRoot}/proxies/create`,
        },
        proxy: (proxyId: string) => `${infraRoot}/proxies/${proxyId}`,
        machinePolicies: {
            root: `${infraRoot}/machinepolicies`,
            create: `${infraRoot}/machinepolicies/create`,
        },
        machinePolicy: (machinePolicyId: string) => `${infraRoot}/machinepolicies/${machinePolicyId}`,
        accounts: {
            root: `${infraRoot}/accounts`,
            create: `${infraRoot}/accounts/create`
        },
        account: (accountId: string) => `${infraRoot}/accounts/${accountId}`
    };
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/infrastructure/components/InfrastructureRoutes/infrastructureRouteLinks.tsx